import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PanZoomComponent } from './components/pan-zoom/pan-zoom.component';
import { PanZoomTemplateService } from './components/pan-zoom/pan-zoom-template.service';
import { PanZoomService } from './pan-zoom.service';

@NgModule({
  imports: [CommonModule, PanZoomComponent],
  declarations: [],
  exports: [PanZoomComponent],
  providers: [PanZoomTemplateService, PanZoomService]
})
export class PanZoomModule {}
